import { Form } from "shared/ui";
import { REQUEST_TYPES } from "shared/config";
import { useTranslation } from "react-i18next";

const RequestorDetails = ({
  form,
  representations,
  requestorFullName,
  requestPlacedBy,
  requestType,
}) => {
  const { t } = useTranslation("RequestBasicDetails");

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = form;

  if (requestType === REQUEST_TYPES.EUROCARD)
    return (
      <>
        <div className="h6 mb-1 lh-base">
          Card Holder: <br />
          <strong>{requestorFullName}</strong>
        </div>
        {requestPlacedBy && (
          <div className="h6 mb-4 lh-base">
            Responsible Person: <br />
            <strong>{requestPlacedBy}</strong>
          </div>
        )}
      </>
    );

  return (
    <div className="h6 mb-4 lh-base">
      {t("labels.requestor")} <br />
      {representations.length ? (
        <>
          <p className="details__representations-label">
            {t("representations_text")}
          </p>
          <Form.Select
            name="representation_id"
            isSearchable={false}
            options={representations}
            register={register}
            control={control}
            setValue={setValue}
            error={errors.representation_id}
          />
          <p className="details__representations-label">
            {t("representations_text_footnote")}
          </p>
        </>
      ) : (
        <strong>{requestPlacedBy ?? requestorFullName}</strong>
      )}
    </div>
  );
};

export default RequestorDetails;
